'use client';

import './styles.css';

import { useMemo } from 'react';

import { Button as NBButton, ButtonProps as NBButtonProps } from 'next-bricks';

import { Route, routes } from 'config/routes';
import { cn } from 'utils/cn';

import styles from './styles.module.css';

export interface ButtonProps extends NBButtonProps {
	linkTo?: Route;
}

function Button({ variant = 'default', ...props }: ButtonProps) {
	// Memo vars
	const linkTo = useMemo(() => {
		if (!props.linkTo) return props.linkTo;

		const route = routes.get(props.linkTo);

		return route || props.linkTo;
	}, [props.linkTo]);

	return (
		<div className={cn('button', styles.button)} style={props.style}>
			<NBButton
				{...props}
				variant={variant}
				linkTo={linkTo}
				loadingProps={
					variant !== 'default'
						? {
								theme: {
									colors: {
										primary: '#fff',
									},
								},
							}
						: undefined
				}
			/>
		</div>
	);
}

export default Button;
